export const INDEX_LINK = "INDEX_LINK";
